module.exports = __webpack_public_path__ + "img/background-light.d7007793.webp";